import _objectSpread from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue";
var _hoisted_1 = {
  class: "left"
};
var _hoisted_2 = {
  key: 0,
  class: "non-returnable-check-box"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  class: "text"
};
var _hoisted_5 = {
  key: 1,
  class: "total text-right"
};
var _hoisted_6 = {
  class: "text"
};
var _hoisted_7 = {
  class: "price-symbol"
};
var _hoisted_8 = {
  class: "price-nums"
};
var _hoisted_9 = {
  class: "price-symbol"
};
var _hoisted_10 = {
  class: "row"
};
var _hoisted_11 = {
  key: 0,
  class: "activity"
};
var _hoisted_12 = {
  class: "activity-text"
};
var _hoisted_13 = {
  class: "price"
};
var _hoisted_14 = {
  class: "activity-text"
};
var _hoisted_15 = {
  class: "price"
};
var _hoisted_16 = {
  key: 1,
  class: "total"
};
var _hoisted_17 = {
  class: "text"
};
var _hoisted_18 = {
  class: "price-symbol"
};
var _hoisted_19 = {
  class: "price-nums"
};
var _hoisted_20 = {
  class: "price-symbol"
};
var _hoisted_21 = {
  class: "right"
};
import { ref, computed } from 'vue';
import ShoppingAuthorizationPopup from './ShoppingAuthorizationPopup.vue';
import { showToast } from 'vant';
import { useStore } from 'vuex';
import { getCustomerConsent } from '@/models/api/orderConfirmApi';
import { priceSplice } from '@/utils/common';
import { useLess } from '@/models/hooks';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { clickEvents } from '@/configs/awsRumConfig';
import { useI18n } from 'vue-i18n';
import constants from '@/constants';
export default {
  __name: 'BuyBox',
  props: {
    price: {
      type: Object,
      default: () => {
        return {
          originalShippingFee: 0,
          shippingFee: 0,
          importFee: 0,
          total: 0,
          discount: 0,
          promotionList: []
        };
      }
    },
    isLoading: {
      type: Boolean,
      default: () => false
    },
    nums: {
      type: Number,
      default: 0
    },
    asinsList: {
      type: Array,
      default: () => []
    },
    nonReturnableTag: {
      type: Boolean
    },
    isPayButtonDisabled: {
      type: Boolean,
      default: () => true
    }
  },
  emits: ['pay', 'checkPay'],
  setup(__props, {
    emit
  }) {
    var props = __props;
    useLess('views/spc/orderConfirm/components/BuyBox.less');
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var store = useStore();
    var CHECKED_SVG = `${constants.IMAGE_URL}assets/svg/checked.svg`;
    var UNCHECKOUT_SVG = `${constants.IMAGE_URL}assets/svg/notChecked.svg`;
    var distanceFromBottom = computed(() => {
      var _ref, _store$state$navigato;
      return (_ref = `${Number((_store$state$navigato = store.state.navigator.agentData) === null || _store$state$navigato === void 0 ? void 0 : _store$state$navigato.bottom) + 12}`) !== null && _ref !== void 0 ? _ref : 0;
    });
    var isChecked = ref(false);
    var checkImg = computed(() => {
      return isChecked.value ? CHECKED_SVG : UNCHECKOUT_SVG;
    });
    var isShowAuthorize = ref(false);
    var isAuthorize = ref(store.state.checkout.isAuthorize);
    var getIsAuth = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$getCustomerCon, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return getCustomerConsent({
                consentType: 'Order'
              });
            case 3:
              _yield$getCustomerCon = _context.sent;
              data = _yield$getCustomerCon.data;
              isAuthorize.value = data.customerConsents.Order.status === constants.CUSTOMER_CONSENT.TRUE;
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              console.log(_context.t0, 'getCustomerConsent---api---error');
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 8]]);
      }));
      return function getIsAuth() {
        return _ref2.apply(this, arguments);
      };
    }();
    var handlePay = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              props.asinsList.forEach(asinid => {
                awsRumHandler.recordClickEvent(_objectSpread(_objectSpread({}, clickEvents.checkoutPage.payNowButton), {}, {
                  asinid
                }));
              });
              if (props.isPayButtonDisabled) {
                _context2.next = 4;
                break;
              }
              emit('checkPay');
              return _context2.abrupt("return");
            case 4:
              _context2.next = 6;
              return getIsAuth();
            case 6:
              if (isAuthorize.value) {
                _context2.next = 9;
                break;
              }
              isShowAuthorize.value = true;
              return _context2.abrupt("return");
            case 9:
              if (!(props.nonReturnableTag && !isChecked.value)) {
                _context2.next = 12;
                break;
              }
              showToast({
                message: t('modules.checkout.PLEASE_CHECK_THE_BOX_AT_THE_BOTTOM_OF_THE_PAGE'),
                overlayClass: 'a-overlay-white',
                className: 'a-toast'
              });
              return _context2.abrupt("return");
            case 12:
              emit('pay');
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function handlePay() {
        return _ref3.apply(this, arguments);
      };
    }();
    var totalAmount = computed(() => {
      var _props$price, _props$price2, _props$price3, _props$price4;
      return (props === null || props === void 0 ? void 0 : (_props$price = props.price) === null || _props$price === void 0 ? void 0 : _props$price.total) + (props === null || props === void 0 ? void 0 : (_props$price2 = props.price) === null || _props$price2 === void 0 ? void 0 : _props$price2.shippingFee) + (props === null || props === void 0 ? void 0 : (_props$price3 = props.price) === null || _props$price3 === void 0 ? void 0 : _props$price3.importFee) - (props === null || props === void 0 ? void 0 : (_props$price4 = props.price) === null || _props$price4 === void 0 ? void 0 : _props$price4.discount);
    });
    var shippingDiscount = computed(() => {
      var _ref4, _props$price5, _props$price6, _discount$toFixed, _discount;
      var discount = 0;
      discount = (_ref4 = (props === null || props === void 0 ? void 0 : (_props$price5 = props.price) === null || _props$price5 === void 0 ? void 0 : _props$price5.originalShippingFee) - (props === null || props === void 0 ? void 0 : (_props$price6 = props.price) === null || _props$price6 === void 0 ? void 0 : _props$price6.shippingFee)) !== null && _ref4 !== void 0 ? _ref4 : 0;
      return (_discount$toFixed = (_discount = discount) === null || _discount === void 0 ? void 0 : _discount.toFixed(2)) !== null && _discount$toFixed !== void 0 ? _discount$toFixed : 0;
    });
    var handleChecked = () => {
      isChecked.value = !isChecked.value;
      if (isChecked.value) {
        awsRumHandler.recordClickEvent(clickEvents.checkoutPage.agreeToTermsAndConditionsButton);
      }
    };
    return (_ctx, _cache) => {
      var _props$price7;
      var _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock("div", {
        class: "order-foot-bar",
        style: _normalizeStyle({
          paddingBottom: distanceFromBottom.value
        })
      }, [_createElementVNode("div", _hoisted_1, [__props.nonReturnableTag ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", {
        class: "checked-box",
        onClick: handleChecked
      }, [_createElementVNode("img", {
        src: checkImg.value,
        alt: ""
      }, null, 8, _hoisted_3), _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('modules.checkout.CONFIRM_ORDER_CONTAINS_UNSUPPORTED_UNCONDITIONAL_RETURN')), 1)])])) : _createCommentVNode("", true), !__props.nonReturnableTag ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('modules.checkout.AMOUNT_TO')), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('common.currencyUnit')), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(priceSplice)(totalAmount.value)[0]), 1), _createElementVNode("div", _hoisted_9, "." + _toDisplayString(_unref(priceSplice)(totalAmount.value)[1]), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, [((_props$price7 = __props.price) === null || _props$price7 === void 0 ? void 0 : _props$price7.discount) > 0 || shippingDiscount.value > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [__props.price.discount > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('modules.checkout.PROMOTION_DISCOUNT')), 1), _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('common.currencyUnit')) + _toDisplayString(__props.price.discount.toFixed(2)), 1)], 64)) : _createCommentVNode("", true), shippingDiscount.value > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("span", _hoisted_14, _toDisplayString(_unref(t)('modules.checkout.SAVED_ON_SHIPPING_FEES')), 1), _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)('common.currencyUnit')) + _toDisplayString(shippingDiscount.value), 1)], 64)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), __props.nonReturnableTag ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)('modules.checkout.AMOUNT_TO')), 1), _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(t)('common.currencyUnit')), 1), _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(priceSplice)(totalAmount.value)[0]), 1), _createElementVNode("div", _hoisted_20, "." + _toDisplayString(_unref(priceSplice)(totalAmount.value)[1]), 1)])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_21, [_createVNode(_component_van_button, {
        color: "#EB1745",
        class: "confirm-btn",
        onClick: handlePay
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('modules.checkout.PAY_NOW')) + " ", 1), _createElementVNode("span", null, "(" + _toDisplayString(__props.nums) + ")", 1)]),
        _: 1
      })]), _createVNode(ShoppingAuthorizationPopup, {
        show: isShowAuthorize.value,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => isShowAuthorize.value = $event)
      }, null, 8, ["show"])], 4);
    };
  }
};